import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toggleTheme } from "../../../store/actions/index";
import { createSvgIcon } from "@mui/material";
import lighticon from "../../../assets/images/lighticon.png";

const lightIcon = createSvgIcon(
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 5.625V3.75M15 26.25V24.375M26.25 15H24.375M5.625 15H3.75M21.6287 8.37125L22.955 7.045M7.045 22.955L8.37 21.63M22.955 22.955L21.63 21.63M8.37 8.37L7.045 7.045M20 15C20 16.3261 19.4732 17.5979 18.5355 18.5355C17.5979 19.4732 16.3261 20 15 20C13.6739 20 12.4021 19.4732 11.4645 18.5355C10.5268 17.5979 10 16.3261 10 15C10 13.6739 10.5268 12.4021 11.4645 11.4645C12.4021 10.5268 13.6739 10 15 10C16.3261 10 17.5979 10.5268 18.5355 11.4645C19.4732 12.4021 20 13.6739 20 15Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);
const darkIcon = createSvgIcon(
  <svg
    width="30"
    height="32"
    viewBox="0 0 30 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4274 1.70001C11.0982 1.69987 8.81911 2.37469 6.86701 3.64232C4.91476 4.91008 3.37352 6.71601 2.43047 8.841C1.48727 10.966 1.18292 13.3185 1.55417 15.6129C1.92557 17.9072 2.95652 20.0446 4.52207 21.7654C6.08746 23.4862 8.12011 24.7164 10.373 25.3067C12.6258 25.8968 15.0018 25.8216 17.2127 25.09C19.4235 24.3584 21.3738 23.0021 22.8267 21.1856C24.2796 19.3692 25.1727 17.1708 25.3974 14.8577C25.4102 14.7194 25.382 14.5805 25.316 14.4584C25.2501 14.3362 25.1496 14.2361 25.0271 14.1705C24.9045 14.105 24.7652 14.0769 24.6267 14.0899C24.4883 14.1029 24.3567 14.1563 24.2486 14.2435C22.7643 15.3495 20.9045 15.8305 19.0688 15.5832C17.2329 15.3357 15.5676 14.3798 14.4306 12.9206C13.2935 11.4614 12.7755 9.61549 12.9876 7.77921C13.1999 5.94307 14.1254 4.26321 15.5654 3.10048C15.6773 3.01705 15.7619 2.90255 15.8085 2.7714C15.8553 2.64011 15.8621 2.49794 15.828 2.36283C15.794 2.22787 15.7206 2.10575 15.6173 2.01215C15.5139 1.91855 15.3851 1.85771 15.2471 1.83695C14.6448 1.74575 14.0366 1.70001 13.4274 1.70001Z"
      stroke="#161D26"
      stroke-width="1.5"
    />
  </svg>
);

const ThemeToggle = () => {
  const theme = useSelector((state) => state.theme);
  const [activeIcon, setActiveIcon] = useState(theme);

  const dispatch = useDispatch();

  useEffect(() => {
    console.log(theme.theme);
    if (theme.theme === "light") {
      setActiveIcon("light");
    } else {
      setActiveIcon("light-new");
    }
  }, [theme]);

  return (
    <div style={{ cursor: "pointer" }} onClick={() => {
      dispatch(toggleTheme())
    }}>
      {/* {theme.theme} */}
      {/* <activeIcon/> */}

      {activeIcon !== "light" ? (
        <div className="lighticon">
          <>
            {" "}
            <svg
              width="30"
              height="30"
              viewBox="0 -4 28 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.4274 1.70001C11.0982 1.69987 8.81911 2.37469 6.86701 3.64232C4.91476 4.91008 3.37352 6.71601 2.43047 8.841C1.48727 10.966 1.18292 13.3185 1.55417 15.6129C1.92557 17.9072 2.95652 20.0446 4.52207 21.7654C6.08746 23.4862 8.12011 24.7164 10.373 25.3067C12.6258 25.8968 15.0018 25.8216 17.2127 25.09C19.4235 24.3584 21.3738 23.0021 22.8267 21.1856C24.2796 19.3692 25.1727 17.1708 25.3974 14.8577C25.4102 14.7194 25.382 14.5805 25.316 14.4584C25.2501 14.3362 25.1496 14.2361 25.0271 14.1705C24.9045 14.105 24.7652 14.0769 24.6267 14.0899C24.4883 14.1029 24.3567 14.1563 24.2486 14.2435C22.7643 15.3495 20.9045 15.8305 19.0688 15.5832C17.2329 15.3357 15.5676 14.3798 14.4306 12.9206C13.2935 11.4614 12.7755 9.61549 12.9876 7.77921C13.1999 5.94307 14.1254 4.26321 15.5654 3.10048C15.6773 3.01705 15.7619 2.90255 15.8085 2.7714C15.8553 2.64011 15.8621 2.49794 15.828 2.36283C15.794 2.22787 15.7206 2.10575 15.6173 2.01215C15.5139 1.91855 15.3851 1.85771 15.2471 1.83695C14.6448 1.74575 14.0366 1.70001 13.4274 1.70001Z"
                stroke="#fff"
                stroke-width="2"
              />
            </svg>
          </>
        </div>
      ) : (
        <div className="lighticon">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 5.625V3.75M15 26.25V24.375M26.25 15H24.375M5.625 15H3.75M21.6287 8.37125L22.955 7.045M7.045 22.955L8.37 21.63M22.955 22.955L21.63 21.63M8.37 8.37L7.045 7.045M20 15C20 16.3261 19.4732 17.5979 18.5355 18.5355C17.5979 19.4732 16.3261 20 15 20C13.6739 20 12.4021 19.4732 11.4645 18.5355C10.5268 17.5979 10 16.3261 10 15C10 13.6739 10.5268 12.4021 11.4645 11.4645C12.4021 10.5268 13.6739 10 15 10C16.3261 10 17.5979 10.5268 18.5355 11.4645C19.4732 12.4021 20 13.6739 20 15Z"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </div>
      )}
      <activeIcon />
    </div>
  );
};

export default ThemeToggle;

// import { createSvgIcon } from "@mui/material";
// import { useState } from "react";

// const DarkthemeIcon = createSvgIcon(
//   <svg
//     width="28"
//     height="28"
//     viewBox="0 0 40 40"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <rect width="28" height="28" rx="20" fill="none" />
//     <path
//       d="M20.018 11C18.4652 10.9999 16.9458 11.4779 15.6444 12.3758C14.3429 13.2738 13.3154 14.553 12.6867 16.0582C12.0579 17.5634 11.855 19.2298 12.1025 20.855C12.3501 22.4801 13.0374 23.9941 14.0811 25.213C15.1247 26.4319 16.4798 27.3033 17.9817 27.7214C19.4836 28.1394 21.0676 28.0861 22.5415 27.5679C24.0154 27.0497 25.3156 26.089 26.2842 24.8023C27.2528 23.5157 27.8482 21.9585 27.998 20.32C28.0065 20.2221 27.9877 20.1237 27.9437 20.0372C27.8998 19.9506 27.8328 19.8797 27.7511 19.8333C27.6694 19.7869 27.5765 19.767 27.4842 19.7762C27.3919 19.7854 27.3042 19.8232 27.2321 19.885C26.2426 20.6684 25.0027 21.0091 23.7789 20.8339C22.555 20.6586 21.4448 19.9815 20.6868 18.9479C19.9287 17.9143 19.5834 16.6068 19.7248 15.3061C19.8663 14.0055 20.4833 12.8156 21.4433 11.992C21.5179 11.9329 21.5743 11.8518 21.6054 11.7589C21.6366 11.6659 21.6411 11.5652 21.6184 11.4695C21.5957 11.3739 21.5468 11.2874 21.4779 11.2211C21.409 11.1548 21.3231 11.1117 21.2311 11.097C20.8296 11.0324 20.4241 11 20.018 11Z"
//       stroke="#EAF0F8"
//       stroke-width="1.5"
//     />
//   </svg>
// );
// const LightthemeIcon = createSvgIcon(
//   <svg
//     width="28"
//     height="28"
//     viewBox="0 0 40 40"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <g filter="url(#filter0_d_932_14260)">
//       <rect x="2" y="2" width="28" height="28" rx="20" fill="white" />
//       <g clip-path="url(#clip0_932_14260)">
//         <path
//           d="M21.9997 12.833V14.4997M21.9997 29.4997V31.1663M31.1663 21.9997H29.4997M14.4997 21.9997H12.833M28.4815 15.5179L27.303 16.6964M16.6964 27.303L15.5179 28.4815M28.4815 28.4815L27.303 27.303M16.6964 16.6964L15.5179 15.5179M26.9997 21.9997C26.9997 24.7611 24.7611 26.9997 21.9997 26.9997C19.2383 26.9997 16.9997 24.7611 16.9997 21.9997C16.9997 19.2383 19.2383 16.9997 21.9997 16.9997C24.7611 16.9997 26.9997 19.2383 26.9997 21.9997Z"
//           stroke="#1877F2"
//           stroke-width="1.5"
//           stroke-linecap="round"
//         />
//       </g>
//     </g>
//     <defs>
//       <filter
//         id="filter0_d_932_14260"
//         x="0"
//         y="0"
//         width="44"
//         height="44"
//         filterUnits="userSpaceOnUse"
//         color-interpolation-filters="sRGB"
//       >
//         <feFlood flood-opacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset />
//         <feGaussianBlur stdDeviation="1" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0.0666667 0 0 0 0 0.329412 0 0 0 0 0.67451 0 0 0 1 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_932_14260"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_932_14260"
//           result="shape"
//         />
//       </filter>
//       <clipPath id="clip0_932_14260">
//         <rect
//           width="20"
//           height="20"
//           fill="white"
//           transform="translate(12 12)"
//         />
//       </clipPath>
//     </defs>
//   </svg>
// );
// const ThemeToggle = () => {
//   const [activeTheme, setActiveTheme] = useState(localStorage.getItem("Theme"));
//   let ActiveIcon;
//   if (activeTheme === "Dark") {
//     ActiveIcon = <DarkthemeIcon />;
//   } else {
//     ActiveIcon = <LightthemeIcon />;
//   }

//   return <div className="theme-toggle-wrapper">{ActiveIcon}
//   {onclick}
//   </div>;
// };

// export default ThemeToggle;
